export { default as AdLink } from './AdLink';



// WEBPACK FOOTER //
// ./src/components/AdCard/AdLink/index.ts